export const FETCH_CONVERSATION_LIST_SUCCESS =
  'FETCH_CONVERSATION_LIST_SUCCESS';
export const ADD_UNREAD_MESSAGE = 'ADD_UNREAD_MESSAGE';
export const REMOVE_CONVERSATION_UNREAD_MESSAGES =
  'REMOVE_CONVERSATION_UNREAD_MESSAGES';
export const SET_UNREAD_MESSAGES_COUNT = 'SET_UNREAD_MESSAGES_COUNT';
export const SET_CONVERSATION = 'SET_CONVERSATION';
